import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ArrowLeftIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M6.75 2L0.75 8M0.75 8L6.75 14M0.75 8H16.75" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

ArrowLeftIcon.displayName = 'ArrowLeftIcon';
